import React from 'react';

import styles from './styled-shared-table.module.scss';
export const Header = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['header']} ${className}` : styles['header']} {...props} />
);

export const TableContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['table-container']} ${className}` : styles['table-container']}
    {...props}
  />
);

export const Table = ({ className, ...props }: React.ComponentPropsWithoutRef<'table'>) => (
  <table className={className ? `${styles['table']} ${className}` : styles['table']} {...props} />
);

export const TableHeader = ({ className, ...props }: React.ComponentPropsWithoutRef<'thead'>) => (
  <thead
    className={className ? `${styles['table-header']} ${className}` : styles['table-header']}
    {...props}
  />
);

export const THead = ({ className, ...props }: React.ComponentPropsWithoutRef<'th'>) => (
  <th className={className ? `${styles['t-head']} ${className}` : styles['t-head']} {...props} />
);

export const Cell = ({ className, ...props }: React.ComponentPropsWithoutRef<'td'>) => (
  <td className={className ? `${styles['cell']} ${className}` : styles['cell']} {...props} />
);

export const Row = ({ className, ...props }: React.ComponentPropsWithoutRef<'tr'>) => (
  <tr className={className ? `${styles['row']} ${className}` : styles['row']} {...props} />
);
